// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "userSelect-kfSwDN": "userSelect-x1hx0egp",
    "cursor-kkrTdU": "cursor-xt0e3qv",
    "display-k1xSpc": "display-x1lliihq",
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/primitives/Touchable.res.js:11"
  },
  inline: {
    "display-k1xSpc": "display-x3nfvp2",
    $$css: "wino-gc:src/primitives/Touchable.res.js:17"
  },
  grow: {
    "flex-kUk6DE": "flex-x98rzlu",
    $$css: "wino-gc:src/primitives/Touchable.res.js:20"
  },
  cursorPointer: {
    "cursor-kkrTdU": "cursor-x1ypdohk",
    $$css: "wino-gc:src/primitives/Touchable.res.js:23"
  }
};
function styleProps(wrap, grow, disabled, additionalStyle) {
  return Stylex.props(styles.root, wrap ? {} : styles.inline, grow ? styles.grow : {}, disabled ? {} : styles.cursorPointer, additionalStyle);
}
let make = React.forwardRef((props, ref) => {
  let href = props.href;
  let __style = props.style;
  let __grow = props.grow;
  let __wrap = props.wrap;
  let ariaProps = props.ariaProps;
  let children = props.children;
  let wrap = __wrap !== undefined ? __wrap : true;
  let grow = __grow !== undefined ? __grow : false;
  let style = __style !== undefined ? Primitive_option.valFromOption(__style) : {};
  let ref$1 = Stdlib_Option.map(ref == null ? undefined : Primitive_option.some(ref), prim => prim);
  let disabled = Stdlib_Option.getOr(Stdlib_Option.orElse(props.disabled, Stdlib_Option.flatMap(ariaProps, props => props.isDisabled)), false);
  let defaultProps_elementType = Stdlib_Option.isSome(href) ? "a" : "div";
  let defaultProps_routerOptions = props.routerOptions;
  let defaultProps_isDisabled = disabled;
  let defaultProps_excludeFromTabOrder = props.excludeFromTabOrder;
  let defaultProps_onPress = props.onPress;
  let defaultProps = {
    elementType: defaultProps_elementType,
    href: href,
    routerOptions: defaultProps_routerOptions,
    isDisabled: defaultProps_isDisabled,
    excludeFromTabOrder: defaultProps_excludeFromTabOrder,
    onPress: defaultProps_onPress
  };
  let props$1 = Stdlib_Option.getOr(Stdlib_Option.map(ariaProps, props => ReactAria.mergeProps(defaultProps, props)), defaultProps);
  let match = ReactAria.useButton(props$1, undefined);
  let match$1 = ReactAria.useLink(props$1, undefined);
  let match$2 = styleProps(wrap, grow, disabled, style);
  let style$1 = match$2.style;
  let className = match$2.className;
  if (href !== undefined) {
    let newrecord = {
      ...match$1.linkProps
    };
    return JsxRuntime.jsx("a", (newrecord.href = href, newrecord.style = style$1, newrecord.className = className, newrecord.ref = ref$1, newrecord.children = children, newrecord));
  }
  let newrecord$1 = {
    ...match.buttonProps
  };
  return JsxRuntime.jsx("div", (newrecord$1.style = style$1, newrecord$1.className = className, newrecord$1.ref = ref$1, newrecord$1.children = children, newrecord$1));
});
let make$1 = React.memo(make);
make$1.displayName = "Touchable";
export { make$1 as make };
/* styles Not a pure module */